/**
 * Copies source object into target object using deep cloning.
 * @param targetObject target object
 * @param sourceObject source object
 * @returns merged target object
 */
export function deepMergeObject(targetObject = {}, sourceObject = {}) {
  // clone the source and target objects to avoid the mutation
  const copyTargetObject = structuredClone(targetObject);
  const copySourceObject = structuredClone(sourceObject);
  // Iterating through all the keys of source object
  Object.keys(copySourceObject).forEach((key) => {
    if (
      typeof copySourceObject[key] === 'object' &&
      !Array.isArray(copySourceObject[key])
    ) {
      // If property has nested object, call the function recursively
      copyTargetObject[key] = deepMergeObject(
        copyTargetObject[key],
        copySourceObject[key],
      );
    } else {
      // else merge the object source to target
      copyTargetObject[key] = copySourceObject[key];
    }
  });

  return copyTargetObject;
}

/**
 * Get pathname part of the URL excluding /
 * @returns pathname without /
 */
export function getPathname() {
  const pathname = window.location.pathname;

  if (!pathname || pathname.length === 0 || pathname === '/') {
    return '';
  }
  return pathname.substring(1, pathname.length);
}
